// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { resetPassword as resetPasswordApi } from "@stoneage/App/Services/ResetPassword/ResetPasswordService";

export interface ResetPasswordParameter {
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandler<ResetPasswordParameter, ServiceResult<ApiParameter>>;

export const ResetPassword: HandlerType = async props => {
    props.apiResult = await resetPasswordApi();
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        // markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const chain = [ResetPassword, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const resetPassword = createHandlerChainRunner(chain, "ResetPassword");
export default resetPassword;
